import React from 'react';
import { Flex, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
const {
  t,
  exists
} = I18N.ns('login.TwoFactorVerify');
export default function TwoFactorVerifyInstructionComponent({
  selectedTwoFactorMethod,
  requestedTwoFactorMessage
}) {
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colM"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "formTitle|title"
  }, requestedTwoFactorMessage ? exists(`title-${selectedTwoFactorMethod?.type}`) ? t(`title-${selectedTwoFactorMethod?.type}`) : t('title') : t('titleSelect')), requestedTwoFactorMessage && /*#__PURE__*/React.createElement(Text, {
    variant: "formBody"
  }, requestedTwoFactorMessage));
}